import { Injectable } from '@angular/core';

const STORAGE_KEY = 'centaiva.superAdmin.companyContext';

@Injectable({ providedIn: 'root' })
export class CompanyContextService {
  getSelectedCompanyId(userId: number): number | null {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}') as Record<string, number>;
      const companyId = Number(stored[String(userId)]);
      return Number.isInteger(companyId) && companyId > 0 ? companyId : null;
    } catch {
      return null;
    }
  }

  setSelectedCompanyId(userId: number, companyId: number): void {
    let stored: Record<string, number> = {};
    try {
      stored = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}') as Record<string, number>;
    } catch {
      stored = {};
    }
    stored[String(userId)] = companyId;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  }
}
